// Стили блоков, которые должны отображаться в режиме презентации
export const PRESENTATION_STYLES = [
  'big',
  'image',
  'colored',
  'normal',
  'normal_emblem',
  'slider',
  'two_pictures',
  'projects',
  'video',
  'quote',
  'bibliography',
  'image_sources',
  'products',
  'podcast',
  'card',
  'link',
  'annotation'
] as const;

// Настройки слайдера
export const SLIDER_SETTINGS = {
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  fade: false,
} as const;

// Размеры сайдбара
export const SIDEBAR_WIDTH = 312;
export const SIDEBAR_PADDING = 16;

// Размеры миниатюр
export const THUMBNAIL_WIDTH = 280;
export const THUMBNAIL_HEIGHT = 158;
export const THUMBNAIL_SCALE = 0.146; // 280/1920

// Максимальное количество проектов в блоке projects
export const MAX_PROJECTS_IN_BLOCK = 3;

// Таймауты для асинхронных операций
export const SCROLL_TIMEOUT = 300;
export const SLIDER_INIT_TIMEOUT = 0;// Стили блоков, которые должны отображаться в режиме презентации
export const PRESENTATION_STYLES = [
  'big',
  'image',
  'colored',
  'normal',
  'normal_emblem',
  'slider',
  'two_pictures',
  'projects',
  'video',
  'quote',
  'bibliography',
  'image_sources',
  'products',
  'podcast',
  'card',
  'link',
  'annotation'
] as const;

// Настройки слайдера
export const SLIDER_SETTINGS = {
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  fade: false,
} as const;

// Размеры сайдбара
export const SIDEBAR_WIDTH = 312;
export const SIDEBAR_PADDING = 16;

// Размеры миниатюр
export const THUMBNAIL_WIDTH = 280;
export const THUMBNAIL_HEIGHT = 158;
export const THUMBNAIL_SCALE = 0.146; // 280/1920

// Максимальное количество проектов в блоке projects
export const MAX_PROJECTS_IN_BLOCK = 3;

// Таймауты для асинхронных операций
export const SCROLL_TIMEOUT = 300;
export const SLIDER_INIT_TIMEOUT = 0;